import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, LayoutGrid, ShoppingCart, User } from 'lucide-react';

const items = [
  { to: '/', label: 'Acasă', icon: Home, testid: 'bottomnav-home' },
  { to: '/catalog', label: 'Catalog', icon: LayoutGrid, testid: 'bottomnav-catalog' },
  { to: '/cart', label: 'Coș', icon: ShoppingCart, testid: 'bottomnav-cart' },
  { to: '/account', label: 'Cont', icon: User, testid: 'bottomnav-account' },
];

const MobileBottomNav = ({ cartCount = 0 }) => {
  const { pathname } = useLocation();

  return (
    <nav
      className="mobile-bottom-nav fixed bottom-0 left-0 right-0 z-40 border-t border-gray-200 bg-white/95 backdrop-blur lg:hidden"
      data-testid="mobile-bottom-nav"
    >
      <div className="mx-auto flex max-w-lg items-stretch justify-around">
        {items.map(({ to, label, icon: Icon, testid }) => {
          const active = to === '/' ? pathname === '/' : pathname.startsWith(to);
          return (
            <Link
              key={to}
              to={to}
              data-testid={testid}
              className={`relative flex min-h-[56px] flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[11px] font-medium transition-colors ${
                active ? 'text-green-600' : 'text-gray-500 active:bg-gray-50'
              }`}
            >
              <span className="relative">
                <Icon className="h-6 w-6" />
                {to === '/cart' && cartCount > 0 && (
                  <span
                    className="absolute -right-2 -top-1.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-green-600 px-1 text-[10px] font-bold text-white"
                    data-testid="bottomnav-cart-count"
                  >
                    {cartCount}
                  </span>
                )}
              </span>
              {label}
              {active && <span className="absolute top-0 h-0.5 w-8 rounded-full bg-green-600" />}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
